<script lang="ts">
  import { Button } from "@/components/ui/button"
  import * as Dialog from "@/components/ui/dialog"
  import type { User } from "@/types"

  interface Props {
    open?: boolean
    frequencyTypeFilters: Array<"periodic" | "ad_hoc">
    statusFilters: Array<"active" | "archived">
    memberFilters: number[]
    members: User[]
    onFrequencyTypeChange: (filters: Array<"periodic" | "ad_hoc">) => void
    onStatusChange: (filters: Array<"active" | "archived">) => void
    onMemberChange: (filters: number[]) => void
    onClose: () => void
  }

  let {
    open = $bindable(false),
    frequencyTypeFilters,
    statusFilters,
    memberFilters,
    members = [],
    onFrequencyTypeChange,
    onStatusChange,
    onMemberChange,
    onClose,
  }: Props = $props()
</script>

<Dialog.Root bind:open>
  <Dialog.Content class="sm:max-w-md">
    <Dialog.Header>
      <Dialog.Title>Filter Task Templates</Dialog.Title>
    </Dialog.Header>
    <div class="space-y-6 py-4">
      <div>
        <h3 class="text-sm font-medium mb-3">Frequency Type</h3>
        <div class="flex gap-2">
          <button
            type="button"
            onclick={() => {
              if (frequencyTypeFilters.includes("periodic")) {
                onFrequencyTypeChange(frequencyTypeFilters.filter((f) => f !== "periodic"))
              } else {
                onFrequencyTypeChange([...frequencyTypeFilters, "periodic"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {frequencyTypeFilters.includes("periodic")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            Periodic
          </button>
          <button
            type="button"
            onclick={() => {
              if (frequencyTypeFilters.includes("ad_hoc")) {
                onFrequencyTypeChange(frequencyTypeFilters.filter((f) => f !== "ad_hoc"))
              } else {
                onFrequencyTypeChange([...frequencyTypeFilters, "ad_hoc"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {frequencyTypeFilters.includes("ad_hoc")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            Ad-hoc
          </button>
        </div>
      </div>
      <div>
        <h3 class="text-sm font-medium mb-3">Status</h3>
        <div class="flex gap-2">
          <button
            type="button"
            onclick={() => {
              if (statusFilters.includes("active")) {
                onStatusChange(statusFilters.filter((f) => f !== "active"))
              } else {
                onStatusChange([...statusFilters, "active"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {statusFilters.includes("active")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            Active
          </button>
          <button
            type="button"
            onclick={() => {
              if (statusFilters.includes("archived")) {
                onStatusChange(statusFilters.filter((f) => f !== "archived"))
              } else {
                onStatusChange([...statusFilters, "archived"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {statusFilters.includes("archived")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            Archived
          </button>
        </div>
      </div>
      {#if members.length > 0}
        <div>
          <h3 class="text-sm font-medium mb-3">Available To</h3>
          <div class="flex flex-wrap gap-2">
            {#each members as member (member.id)}
              <button
                type="button"
                onclick={() => {
                  if (memberFilters.includes(member.id)) {
                    onMemberChange(memberFilters.filter((id) => id !== member.id))
                  } else {
                    onMemberChange([...memberFilters, member.id])
                  }
                }}
                class="px-3 py-1.5 text-sm rounded-full border transition-colors {memberFilters.includes(member.id)
                  ? "bg-primary text-primary-foreground border-primary"
                  : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
              >
                {member.name}
              </button>
            {/each}
          </div>
        </div>
      {/if}
    </div>
    <Dialog.Footer>
      <Button variant="outline" onclick={onClose}>Close</Button>
    </Dialog.Footer>
  </Dialog.Content>
</Dialog.Root>
